import React, { useEffect, useRef, useState } from "react";
import InformationCard from "../../../components/RepresentationLayout/InformationCard";
import { useTranslation } from "react-i18next";
import { DataSectionLoader } from "../Loaders/DataSectionLoader";

import iniciativas from "../../../assets/iconos/iniciativas.svg"
import asignado from "../../../assets/iconos/asignado.svg"
import avance from "../../../assets/iconos/avance.svg"
import productores from "../../../assets/iconos/productores.svg"
import logros from "../../../assets/iconos/logros.svg"
import resultados from "../../../assets/iconos/resultados.svg"
import territorios from "../../../assets/iconos/territorios.svg"
import ejecutado from "../../../assets/iconos/ejecutado.svg"
import porcentaje_ejecutado from "../../../assets/iconos/porcentaje_ejecutado.svg"
import contrapartes from "../../../assets/iconos/contrapartes.svg"
import { IInformacionGeneral } from "../../../interfaces/InformacionGeneral";
import { getInformacionGeneralReps } from "../../../api/informacionGeneral";
import { getCantidadContrapartes } from "../../../api/contrapartesWs";
import { IInstrumentosEjecucion } from "../../../interfaces/InstrumentosEjecucion";
import { getExecutionDataGlobal, getInstrumentExecutionData } from "../../../api/instrumentExecution";
import { Sections } from "../../../util/types";

const DataSection:React.FC<{ 
  pais?:string, 
  refreshActiveSection: (section: Sections) => void,
  activeSection?:Sections }> = ({ pais, refreshActiveSection, activeSection }) => {

  const [infoGeneral, setInfoGeneral] = useState<IInformacionGeneral>()
  const [ejecucion, setEjecucion] = useState<IInstrumentosEjecucion>()
  const [cantContrapartes, setCantContrapartes] = useState<number>()

  const loadData = () => {
    setInfoGeneral(undefined)
    setEjecucion(undefined)
    setCantContrapartes(undefined)
    
    if (!pais) {
      getInformacionGeneralReps("")
        .then((res) => {
          setInfoGeneral(res)
        })
      getExecutionDataGlobal()
        .then((res) => {
          setEjecucion(res)
        })
      getCantidadContrapartes()
        .then((res) => {
          setCantContrapartes(res)
        })
      return
    }

    getInformacionGeneralReps(pais!)
      .then((response) => {
        setInfoGeneral(response);
        return;
      });
    getInstrumentExecutionData(pais!)
      .then((response) => {
        setEjecucion(response);
        return;
      }, (reason) => {
        //No hay datos entonces logueo a la consola
        console.log("No data available")
      });
    getCantidadContrapartes({ unidad: pais })
      .then((res) => {
        setCantContrapartes(res)
      })
  }

  useEffect(() => {

    loadData()

    return () => {
      //Reinicio los estados
      setInfoGeneral(undefined);
      setEjecucion(undefined);
      setCantContrapartes(undefined)
    }
  }, [pais]);

  const { t } = useTranslation("translation", {
    keyPrefix: "home.data_section",
  });

  if (!infoGeneral || !ejecucion) {
    return (
      <div className="col-md-8">
        <DataSectionLoader />
      </div>
    );
  }
  return (
    <>
        <div className="col-md-8">
          <div className="row">
            <div className="col-lg-3 col-sm-12">
              <InformationCard
                icon={iniciativas}
                value={infoGeneral.cantidadProyectos}
                text={t("iniciativas")}
                section="initiatives"
                activeSection={activeSection}
                onClick={() => {
                  refreshActiveSection("initiatives")
                }}
              />
            </div>
            <div className="col-lg-3 col-sm-12">
              <InformationCard
                icon={resultados}
                value={infoGeneral?.cantidadResultados}
                text={t("resultados")}
              />
            </div>
            <div className="col-lg-3 col-sm-12">
              <InformationCard
                icon={avance}
                value={Math.round(infoGeneral?.porcentajeAvance!)}
                text={t("avance")}
                suffix="%"
              />
            </div>
            <div className="col-lg-3 col-sm-12">
              <InformationCard
                icon={productores}
                value={infoGeneral?.cantidadAgricultores}
                text={t("productores")}
                headlineSize="h4"
              />
            </div>
            <div className="col-lg-3 col-sm-12">
              <InformationCard
                icon={logros}
                value={infoGeneral.cantidadLogros ? infoGeneral.cantidadLogros : 0}
                text={t("logros")}
                section="logros"
                activeSection={activeSection}
                onClick={() => {
                  refreshActiveSection("logros")
                }}
              />
            </div>
            <div className="col-lg-3 col-sm-12">
              <InformationCard
                icon={territorios}
                value={infoGeneral.cantidadTerritorios ? infoGeneral.cantidadTerritorios : 0}
                text={t("territorios")}
                activeSection={activeSection}
                section="territorios"
                onClick={() => {
                  refreshActiveSection("territorios")
                }}
              />
            </div>
            <div className="col-lg-3 col-sm-12">
              <InformationCard
                icon={contrapartes}
                value={cantContrapartes}
                text={t("contrapartes")}
                section="contrapartes"
                activeSection={activeSection}
                onClick={() => {
                  refreshActiveSection("contrapartes")
                }}
              />
            </div>
            <div className="col-lg-3 col-sm-12">
              <InformationCard
                icon={porcentaje_ejecutado}
                value={ejecucion?.porcentajeAvance}
                text={t("excecution")}
                headlineSize="h4"
                suffix="%"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg col-sm-12">
              <InformationCard
                icon={asignado}
                value={ejecucion.presupuesto}
                text={t("asignado")}
                prefix="$"
                section="allocated"
                activeSection={activeSection}
                onClick={() => {
                  refreshActiveSection("allocated")
                }}
              />
            </div>
            <div className="col-lg col-sm-12">
              <InformationCard
                icon={ejecutado}
                value={ejecucion?.ejecucion}
                text={t("excec_ammount")}
                prefix="$"
                section="executed"
                activeSection={activeSection}
                onClick={() => {
                  refreshActiveSection("executed")
                }}
              />

            </div>
          </div>
        </div>
    </>
  );
};

export default DataSection;
